import './styles';

import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import UUID from 'uuid';

export default class Tooltip extends React.Component {
    constructor(props) {
        super(props);

        this.id = UUID.v4();
    }

    render() {
        return (
            <div data-tooltip-id={this.id} className="Tooltip" onClick={this.props.onClick}>
                <ReactTooltip id={this.id} effect="solid" className="Tooltip-hover">
                    {this.props.text}
                </ReactTooltip>
            </div>
        );
    }
}
